import React from 'react';
import { Form, Input } from 'antd';
import ModalForm from 'components/ModalForm';
import QueryBuilderInput from 'components/QueryBuilder/QueryBuilderInput';
import { gql } from '@apollo/client';
import { useMutation, useQuery } from 'hooks/apollo';
import useCustomer from 'hooks/useCustomer';

const SEGMENT_QUERY = gql`
  query($id: ID!) {
    segment(id: $id) {
      id
      title
      query
    }
  }
`;

const CREATE_MUTATION = gql`  
  mutation CreateSegment($input: SegmentInput!) {
    createSegment(input: $input) {
      id
    }
  }
`;

const UPDATE_MUTATION = gql`
  mutation UpdateSegment($id: ID!, $input: SegmentInput!) {
    updateSegment(id: $id, input: $input) {
      id
    }
  }
`;

const queryValidator = async (_, value) => {
  if (!value?.rules?.length) {
    throw new Error('Query is empty');
  }

  for (const rule of value.rules) {
    if (!rule.field) {
      throw new Error('Query rule without field');
    }

    if (['in', 'notIn', 'between', 'notBetween', 'contains', 'doesNotContain', 'matchesRegex', '=', '!=', '>', '<', '>=', '<='].includes(rule.operator) && (rule.value == null || rule.value === '')) {
      throw new Error('Query rule without value');
    }
  }
};

const SegmentEditor = ({ open, onCancel, onDone, segmentId }) => {
  const { data } = useQuery(SEGMENT_QUERY, { variables: { id: segmentId }, skip: !segmentId });
  const { customerId } = useCustomer();
  const [createSegment] = useMutation(CREATE_MUTATION);
  const [updateSegment] = useMutation(UPDATE_MUTATION);

  const onSubmit = async (values) => {
    if (segmentId) {
      await updateSegment({ variables: { id: segmentId, input: values } });
    } else {
      await createSegment({ variables: { input: values } });
    }
  };

  return (
    <ModalForm title="Segment Editor" open={open} onCancel={onCancel} onDone={onDone} onSubmit={onSubmit} fullWidth initialValues={data?.segment} formReset={data}>
      <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Title is required' }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Query" name="query" rules={[{ validator: queryValidator }]}>
        <QueryBuilderInput customerId={customerId} />
      </Form.Item>
    </ModalForm>
  );
};

export default SegmentEditor;
